import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-wallet-icon',
  templateUrl: './shopping-wallet.component.html'
})
export class ShoppingWalletComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
